import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";
import { DisclosureCatalogue } from "JS/Models/Disclosure";

export class DisclosureService extends BaseService {
    getDisclosures() {
        return this.ngCall<DisclosureCatalogue>(
            "get",
            appConstants.ngEndpoints.disclosures,
        );
    }
}
